import { ChangeInvestmentInstructionSubmissionTypeEnum } from '../../enum/shared/change-investment-instruction-submission-type.enum';
import { AccountTypeIdEnum } from '../../enum/shared/account-type-id.enum';

export class InvestmentInstructionFormRequest {
  public submissionTypeId: ChangeInvestmentInstructionSubmissionTypeEnum;
  public accountTypeId: AccountTypeIdEnum;
  public accountIds: number[];

  constructor(
    submissionTypeId: ChangeInvestmentInstructionSubmissionTypeEnum,
    accountTypeId: AccountTypeIdEnum,
    accountIds: number[]
  ) {
    this.submissionTypeId = submissionTypeId;
    this.accountTypeId = accountTypeId;
    this.accountIds = accountIds;
  }
}
